/*
 * @Author: dengyongliang
 * @Date: 2021-05-28 09:25:57
 * @LastEditTime: 2021-06-08 15:59:34
 * @LastEditors: dengyongliang
 * @Description: 空
 */
import * as api from '@/api/brand'

export default {
  state: {},
  mutations: {},
  actions: {
    BRAND_SAFE_MONITOR_APPLY(context, payload) {
      return api
        .BRAND_SAFE_MONITOR_APPLY(payload.brandNameCn, payload.brandNameEn, payload.brandNamePy, payload.brandNameOther, payload.brandIndustry, payload.domainSuffix, payload.holdDomains, payload.holdTms, payload.callPhone, payload.callCode)
        .then(res => {
          return res
        })
        .catch(error => {
          return error
        })
    },
    BRAND_SAFE_MONITOR_FILL(context, payload) {
      return api
        .BRAND_SAFE_MONITOR_FILL(payload.id, payload.contactName, payload.contactCompany, payload.contactEmail)
        .then(res => {
          return res
        })
        .catch(error => {
          return error
        })
    },
    BRAND_SAFE_MONITOR_CORE_DOMAIN_LIST(context, payload) {
      return api
        .BRAND_SAFE_MONITOR_CORE_DOMAIN_LIST(payload.safeCode, payload.pageNum, payload.pageSize)
        .then(res => {
          return res
        })
        .catch(error => {
          return error
        })
    },
    BRAND_SAFE_MONITOR_SIMILAR_TM_LIST(context, payload) {
      return api
        .BRAND_SAFE_MONITOR_SIMILAR_TM_LIST(payload.safeCode, payload.orderProperty, payload.orderType, payload.pageNum, payload.pageSize)
        .then(res => {
          return res
        })
        .catch(error => {
          return error
        })
    },
    BRAND_SAFE_MONITOR_EXCEPT_DOMAIN_LIST(context, payload) {
      return api
        .BRAND_SAFE_MONITOR_EXCEPT_DOMAIN_LIST(payload.safeCode, payload.pageNum, payload.pageSize)
        .then(res => {
          return res
        })
        .catch(error => {
          return error
        })
    },
    BRAND_SAFE_MONITOR_MONITOR_DOMAIN_LIST(context, payload) {
      return api
        .BRAND_SAFE_MONITOR_MONITOR_DOMAIN_LIST(payload.safeCode, payload.pageNum, payload.pageSize)
        .then(res => {
          return res
        })
        .catch(error => {
          return error
        })
    },
    BRAND_SAFE_MONITOR_INFO(context, payload) {
      return api
        .BRAND_SAFE_MONITOR_INFO(payload.safeCode)
        .then(res => {
          return res
        })
        .catch(error => {
          return error
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/brand.js